import { render } from "./GroupPermissions.vue?vue&type=template&id=5c0782dd&ts=true"
import script from "./GroupPermissions.vue?vue&type=script&lang=ts"
export * from "./GroupPermissions.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__